<template>
  <header class="header bg-header outer-header">
    <div class="container px-0">
      <nav class="navbar navbar-expand-lg navbar-light p-0">
        <div class="container-fluid">
          <router-link to="/home" class="navbar-brand">
            <img
              src="/images/logo.svg"
              width="200"
              height="39"
              alt="Logo"
              class="img-fluid header-logo logo-white mr-3" />
            <img
              src="/images/logo-dark.svg"
              width="140"
              height="39"
              alt="Logo"
              class="img-fluid header-logo logo-black mr-3" />
          </router-link>

          <div
            class="collapse navbar-collapse header-navbar"
            id="navbarSupportedContent">
            <ul class="navbar-nav outer-nav-ul ms-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <router-link to="/home" class="nav-link">Home</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/our-procedure" class="nav-link"
                  >our procedure</router-link
                >
              </li>
              <li class="nav-item">
                <router-link to="/success-stories" class="nav-link"
                  >success stories</router-link
                >
              </li>
              <li class="nav-item">
                <router-link to="/contact" class="nav-link"
                  >Contact us</router-link
                >
              </li>
              <li class="nav-item me-3 mb-lg-0 mb-3"></li>
              <li class="nav-item"></li>
            </ul>
            <!-- <div class="lang-dd me-md-3 me-1">
        <select class="form-select" aria-label="Default select example" v-model="lang" @change="selectLang()">
        <option selected value="en" style="background:#333;">EN</option>
        <option value="mr" style="background:#333;">MR</option>
      </select>
      </div> -->
          </div>
          <button
            type="button"
            class="btn btn-brand-2 me-md-3 me-2 header-btn"
            v-on:click="ShowLoginModel()">
            Login
          </button>
          <button
            type="button"
            v-on:click="ShowRegister()"
            class="btn btn-brand-1 m-0 me-md-3 me-2 header-btn">
            <!-- v-on:click="$refs.signupModal.showModal()" -->
            Register free
          </button>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: ">
              <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"></path>
            </svg>
          </button>
        </div>
      </nav>
      <!-- <SignUp ref="signupModal" /> -->
      <TextModal ref="loginModal">
        <Form ref="loginForm" @submit="getLogin()">
          <div class="row border-0 p-4 text-align-last-center">
            <div class="col-12" style="text-align-last: center">
              <h5 class="modal-title" id="loginModalLabel">Login</h5>
              <button
                type="button"
                id="login-close"
                class="btn-close"
                style="position: absolute; top: 25px; right: 20px"
                v-on:click="$refs.loginModal.closeModal()"></button>
            </div>
          </div>
          <div class="modal-body pt-0">
            <ul
              class="nav nav-pills mb-3 tab-style-1"
              id="login-tab"
              role="tablist">
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link active"
                  id="phone-tab"
                  data-bs-toggle="pill"
                  href="#tab_2"
                  role="tab"
                  aria-controls="tab_2"
                  aria-selected="false"
                  v-on:click="changeTab('mobile')"
                  >Mobile Number</a
                >
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link "
                  id="email-tab"
                  data-bs-toggle="pill"
                  href="#tab_1"
                  role="tab"
                  aria-controls="tab_1"
                  aria-selected="true"
                  v-on:click="changeTab('email')"
                  >Email Address
                </a>
              </li>
            </ul>
            <div class="tab-content form-style" id="login-tabContent">
              <div
                v-if="currentTab == 'email'"
                :class="
                  currentTab == 'email'
                    ? 'tab-pane fade show active'
                    : 'tab-pane fade'
                "
                id="tab_1"
                role="tabpanel"
                aria-labelledby="eamil-tab">
                <div class="form-group">
                  <label>Email Address</label>
                  <Field
                    type="email"
                    id="email"
                    class="form-control"
                    name="email"
                    placeholder="Email"
                    v-model="loginData.email"
                    rules="required:Email|email"
                    :validateOnInput="true" />
                </div>
                <ErrorMessage name="email" class="validation-msg" />
              </div>
              <div
                v-if="currentTab == 'mobile'"
                :class="
                  currentTab == 'mobile'
                    ? 'tab-pane fade show active'
                    : 'tab-pane fade'
                "
                id="tab_2"
                role="tabpanel"
                aria-labelledby="phone-tab">
                <div class="form-group">
                  <label>Mobile Number</label>
                  <Field
                    type="text"
                    id="mobile_no"
                    class="form-control mobile_no"
                    name="mobile"
                    placeholder="Mobile Number"
                    v-slot="{ field }"
                    v-model="loginData.mobile"
                    rules="required:Mobile Number"
                    :validateOnInput="true">
                    <PhoneCode
                      id="mobile"
                      placeholder="Mobile Number"
                      v-model:countryCode="loginData.country_code"
                      v-model="loginData.mobile"
                      v-model:dialCode="loginData.dial_code"
                      v-bind="field" />
                  </Field>
                </div>
                <ErrorMessage name="mobile" class="validation-msg" />
              </div>
              <div class="form-group align-items-center mb-3">
                <label>Password</label>
                <div class="input-group mb-3">
                  <Field
                    :type="newPasswordFieldType"
                    id="password"
                    name="password"
                    class="form-control password"
                    placeholder="Password"
                    v-model="loginData.password"
                    v-on:keydown.space="$event.preventDefault()"
                    rules="required:Password|minLength:6|password"
                    :validateOnInput="true" /><span
                    class="input-group-text"
                    id="basic-addon2"
                    style="border-radius: 0px 8px 8px 0px"
                    ><a v-on:click="switchVisibilityNew" class="psw-icon"
                      ><img :src="imageNew" width="20" /></a
                  ></span>
                </div>
                <ErrorMessage name="password" class="validation-msg" />
              </div>
              <div
                class="d-flex justify-content-between align-items-center text-center">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-on:change="setData()"
                    value="true"
                    v-model="is_check"
                    id="rememberMe" />
                  <label class="form-check-label" for="rememberMe">
                    Remember Me
                  </label>
                </div>
                <p class="text-md-right mb-0">
                  <a
                    v-on:click="ShowForget()"
                    class="text-color-2 cursor-pointer">
                    Forgot Password ?</a
                  >
                </p>
              </div>
              <div class="my-3 text-center">
                <button
                  class="btn btn-lg btn-brand-1 px-5"
                  id="login-button-new">
                  Login
                </button>
              </div>
              <div class="d-flex justify-content-center">
                <p class="mb-0 mr-1 font-less">Don't have an account ?</p>
                <a
                  v-on:click="ShowRegister()"
                  class="text-color-2 cursor-pointer font-less">
                  &nbsp; Register Free</a
                >
              </div>
            </div>
          </div>
        </Form>
      </TextModal>
      <TextModal ref="forgetModal">
        <!-- <div
    class="modal fade login-modal"
    id="ForgotPassword"
    tabindex="-1"
    aria-labelledby="loginModalLabel"
    aria-hidden="true"
  > -->
        <div>
          <Form @submit="forgotPassword()" ref="forgetForm">
            <div class="row border-0 p-4 text-align-last-center">
              <div class="col-11" style="text-align-last: center">
                <h5 class="modal-title ml-2" id="loginModalLabel">
                  Forgot Password ?
                </h5>
              </div>
              <div class="col-1" style="text-align-last: end">
                <button
                  type="button"
                  id="login-close"
                  class="btn-close"
                  v-on:click="$refs.forgetModal.closeModal()"></button>
              </div>
            </div>
            <div class="modal-body pt-0 form-style">
              <div class="form-group" v-if="currentTab == 'email'">
                <label for="">Enter your Email Id</label>
                <Field
                  type="email"
                  id="id_forget_email"
                  class="form-control"
                  name="forget_email"
                  placeholder="Email"
                  v-model="forgotData.email"
                  rules="required:email|email"
                  :validateOnInput="true" />
              </div>
              <div class="form-group" v-if="currentTab == 'mobile'">
                <label for="">Enter your Mobile Number</label>
                <Field
                  type="email"
                  id="id_forget_email"
                  class="form-control"
                  name="forget_email"
                  placeholder="Mobile Number"
                  v-model="forgotData.email"
                  rules="required:Mobile Number"
                  :validateOnInput="true" />
              </div>
              <ErrorMessage name="forget_email" class="validation-msg" />
              <div class="text-center">
                <button class="btn btn-brand-1 btn-block" id="forgot-button">
                  Submit
                </button>
              </div>
            </div>
          </Form>
        </div>
      </TextModal>

      <TextModal ref="otpModel">
        <div class="modal-dialog modal-dialog-centered" style="margin: 0px">
          <div class="modal-content">
            <div class="modal-header px-md-5 border-0">
              <h5 class="modal-title" id="loginModalLabel">
                OTP Confirmations
              </h5>
              <button
                type="button"
                class="btn-close"
                v-on:click="$refs.otpModel.closeModal()"></button>
            </div>
            <div class="modal-body pt-0 text-center">
              <p class="text-secondary font-14">
                Please enter the verification code sent to your registered<br />
                {{ this.currentTab == "mobile" ? "mobile" : "email" }}
              </p>
              <Form ref="otpModal" @Submit="ForgotverifyOtp()">
                <div class="form-group otp-element mb-0 col-md-10 mx-auto mb-4">
                  <div class="text-center mb-4 digit-group">
                    <Field
                      id="codeBox_1"
                      type="text"
                      name="otp1"
                      class="otp-control ml-1"
                      maxlength="1"
                      rules="required"
                      validateOnInput="true"
                      v-on:keyup="onKeyUpEvent(1, $event)"
                      v-on:keyup.enter="verifyOtp()"
                      v-on:focus="onFocusEvent(1)" />
                    <Field
                      id="codeBox_2"
                      type="text"
                      name="otp2"
                      class="otp-control ml-1"
                      maxlength="1"
                      rules="required"
                      :validateOnInput="true"
                      v-on:keyup="onKeyUpEvent(2, $event)"
                      v-on:keyup.enter="verifyOtp()"
                      v-on:focus="onFocusEvent(2)" />
                    <Field
                      id="codeBox_3"
                      type="text"
                      name="otp3"
                      class="otp-control ml-1"
                      maxlength="1"
                      rules="required"
                      :validateOnInput="true"
                      v-on:keyup="onKeyUpEvent(3, $event)"
                      v-on:keyup.enter="verifyOtp()"
                      v-on:focus="onFocusEvent(3)" />
                    <Field
                      id="codeBox_4"
                      type="text"
                      name="otp4"
                      class="otp-control ml-1"
                      maxlength="1"
                      rules="required:OTP"
                      :validateOnInput="true"
                      v-on:keyup="onKeyUpEvent(4, $event)"
                      v-on:keyup.enter="verifyOtp()"
                      v-on:focus="onFocusEvent(4)" />
                  </div>
                  <ErrorMessage name="otp4" class="text-danger" />

                  <div class="text-center mb-4">
                    <button
                      class="btn btn-brand-1 btn-block"
                      id="new-verify-otp-button">
                      Submit
                    </button>
                  </div>
                  <div class="verification">
                    <!-- Didn’t Get the code? -->
                    <a class="font-weight-bold"
                      ><a
                        class="font-weight-bold"
                        style="cursor: pointer"
                        id="resend-button"
                        v-on:click="resend()"
                        >Resend</a
                      ></a
                    >
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </TextModal>
      <TextModal ref="membershipPlan">
        <div>
          <div class="row col-12 px-md-5 border-0 p-4 text-align-last-center">
            <div class="col-1" style="text-align-last: end"></div>
          </div>
          <div class="modal-body pt-0 form-style">
            <div class="form-group">
              <h4 for="">Buy membership plan</h4>
            </div>
            <div class="text-center">
              <button
                class="btn btn-brand-1 btn-block"
                v-on:click="gotoDashboard()">
                Ok
              </button>
            </div>
          </div>
        </div>
      </TextModal>

      <TextModal ref="completeProfile">
        <div>
          <!-- <div class="row col-12 px-md-5 border-0 p-4 text-align-last-center">
            <div class="col-1" style="text-align-last: end"></div>
          </div> -->
          <div class="modal-body pt-4 form-style">
            <div class="form-group">
              <h4 for="">Please complete the profile</h4>
            </div>
            <div class="text-center">
              <button
                class="btn btn-brand-1 btn-block"
                v-on:click="gotoDashboard()">
                Ok
              </button>
            </div>
          </div>
        </div>
      </TextModal>
      <ErrorComponent ref="errorComponent" />
    </div>
  </header>
</template>
<script>
import TextModal from "@/components/TextModal.vue";
// import SignUp from "../components/signup.vue";
import ErrorComponent from "@/components/ErrorComponent";
import PhoneCode from "@/components/PhoneCodePicker/PhoneCode";
// import Datepicker from "@vuepic/vue-datepicker";
import { Form, Field, ErrorMessage } from "vee-validate";
export default {
  name: "OuterHeader",
  components: {
    // SignUp,
    TextModal,
    PhoneCode,
    Form,
    Field,
    ErrorMessage,
    ErrorComponent,
  },
  data() {
    return {
      newPasswordFieldType: "password",
      PasswordFieldType: "password",
      image: "/images/show-psw.svg",
      imageNew: "/images/show-psw.svg",
      detail: {},
      currentTab: "mobile",
      is_check: false,
      loginData: {
        role: "USER",
        is_verified_mobile: "",
      },
      forgotData: {},
      url: "",
    };
  },
  mounted() {
    this.$i18n.locale = localStorage.getItem("language");
    this.getData();
  },
  methods: {
    ShowRegister() {
      this.$refs.loginModal.closeModal();
      this.$emit("showRegister");
    },
    ShowLoginModel() {
      this.$refs.loginModal.showModal();
      this.$emit("closeRegister");
    },
    selectLang() {
      this.$i18n.locale = this.lang;
      localStorage.setItem("language", this.lang);
    },
    gotoDashboard() {
      this.$refs.completeProfile.closeModal();
      this.$refs.membershipPlan.closeModal();
      this.$router.push("/dashboard");
    },
    // showRegister() {
    //   this.$refs.loginModal.closeModal();
    //   this.$refs.signupModal.showModal();
    // },
    showOtpModel() {
      this.$refs.otpModel.closeModal();
      this.onFocusEvent(1);
      this.$refs.otpModel.showModal();
    },
    ShowForget() {
      this.$refs.loginModal.closeModal();
      this.$refs.forgetModal.showModal();
      // this.forgotData.email = "",
      this.$refs.forgetForm.resetForm();
    },
    changeTab(tab) {
      this.currentTab = tab;
    },
    setData() {
      if (this.is_check) {
        if (this.is_check) {
          localStorage.setItem("is_check", this.is_check);
        }
        if (this.loginData.email) {
          localStorage.setItem("email", this.loginData.email);
        }
        if (this.loginData.mobile) {
          localStorage.setItem("mobile", this.loginData.mobile);
        }
        if (this.loginData.password) {
          localStorage.setItem("password", this.loginData.password);
        }
        if (this.loginData.country_code) {
          localStorage.setItem("country_code", this.loginData.country_code);
        }
        if (this.loginData.dial_code) {
          localStorage.setItem("dial_code", this.loginData.dial_code);
        }
      } else {
        localStorage.clear();
      }
    },
    getData() {
      if (localStorage.getItem("is_check")) {
        this.is_check = localStorage.getItem("is_check");
      }
      if (localStorage.getItem("email")) {
        this.loginData.email = localStorage.getItem("email");
      }
      if (localStorage.getItem("mobile")) {
        this.loginData.mobile = localStorage.getItem("mobile");
      }
      if (localStorage.getItem("password")) {
        this.loginData.password = localStorage.getItem("password");
      }
      if (localStorage.getItem("country_code")) {
        this.loginData.country_code = localStorage.getItem("country_code");
      }
      if (localStorage.getItem("dial_code")) {
        this.loginData.dial_code = localStorage.getItem("dial_code");
      }
    },
    getLogin() {
      this.setData();
      if (this.currentTab == "mobile") {
        this.url = "/mobile-login";
      }
      if (this.currentTab == "email") {
        this.url = "/login";
      }
      this.$api
        .postAPI({
          _action: this.url,
          _body: this.loginData,
          _buttonId: "login-button-new",
        })
        .then((res) => {
          if (res && res.access_token) {
            localStorage.setItem("access_token", res.access_token);
          }
          this.getMeCall();
        });
    },
    forgotPassword() {
      if (this.currentTab == "email") {
        this.$api
          .postAPI({
            _action: "/forgot/password",
            _body: this.forgotData,
            _buttonId: "forgot-button",
          })
          .then((res) => {
            this.$refs.forgetModal.closeModal();
            if (res) {
              if (this.currentTab == "mobile") {
                localStorage.setItem("mobile", this.forgotData.email);
              }
              if (this.currentTab == "email") {
                localStorage.setItem("email", this.forgotData.email);
              }
              this.showOtpModel();
            }
            this.$notify({
              type: "success",
              text: res.message,
            });
          });
      } else if (this.currentTab == "mobile") {
        this.$api
          .postAPI({
            _action: "/forgot/password-mobile",
            _body: this.forgotData,
            _buttonId: "forgot-button",
          })
          .then((res) => {
            this.$refs.forgetModal.closeModal();
            if (res) {
             if (this.currentTab == "mobile") {
                localStorage.setItem("mobile", this.forgotData.email);
              }
              if (this.currentTab == "email") {
                localStorage.setItem("email", this.forgotData.email);
              }
              this.showOtpModel();
            }
            this.$notify({
              type: "success",
              text: res.message,
            });
          });
      }
    },
    getCodeBoxElement(index) {
      return document.getElementById("codeBox_" + index);
    },
    onKeyUpEvent(index, event) {
      if (index < 4) {
        const eventCode = event.which || event.keyCode;
        if (this.getCodeBoxElement(index).value.length === 1) {
          if (index !== 4) {
            this.getCodeBoxElement(index + 1).focus();
          } else {
            this.getCodeBoxElement(index).blur();
          }
        }
        if (eventCode === 8 && index !== 1) {
          this.getCodeBoxElement(index - 1).focus();
        }
      }
    },
    onFocusEvent(index) {
      if (index < 4) {
        for (var item = 1; item < index; item++) {
          const currentElement = this.getCodeBoxElement(item);
          if (!currentElement.value) {
            currentElement.focus();
            break;
          }
        }
      }
    },
    ForgotverifyOtp() {
      var obj = {};
      if (this.currentTab == "mobile") {
        obj.email = localStorage.getItem("mobile");
      }
      if (this.currentTab == "email") {
        obj.email = localStorage.getItem("email");
      }
      obj.currentTab = this.currentTab;
      // obj.email = localStorage.getItem("email");
      obj.otp =
        document.getElementById("codeBox_1").value +
        "" +
        document.getElementById("codeBox_2").value +
        "" +
        document.getElementById("codeBox_3").value +
        "" +
        document.getElementById("codeBox_4").value;
      this.$api
        .putAPI({
          _action: "/verify/otp",
          _body: obj,
          _buttonId: "new-verify-otp-button",
        })
        .then(() => {
          if (this.type == "VERIFICATION") {
            if (this.currentTab == "mobile" || this.currentTab == "email") {
              this.$router.push("/dashboard");
            }
          } else {
            localStorage.setItem("token", obj.otp);
            this.$router.push("/reset-password");
          }
        })
        .catch(() => {});
    },
    resend() {
      var obj = {};
      if (this.currentTab == "mobile") {
        obj.email = localStorage.getItem("mobile");
      }
      if (this.currentTab == "email") {
        obj.email = localStorage.getItem("email");
      }
      this.$api
        .postAPI({
          _action: "/resend/otp",
          _body: obj,
          _buttonId: "resend-button",
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
        })
        .catch(() => {});
    },

    resendOtp(type) {
      this.$refs.errorComponent.updateFormLoader(true);
      var obj = {};
      if (this.currentTab == "mobile") {
        obj.email = localStorage.getItem("mobile");
      }
      if (this.currentTab == "email") {
        obj.email = localStorage.getItem("email");
      }
      this.$api
        .postAPI({
          _action: "/resend/otp",
          _body: obj,
          _buttonId: "resend-button",
        })
        .then((res) => {
          this.$refs.errorComponent.updateFormLoader(false);
          if (type) {
            this.type = type;
          }
          this.$refs.otpModel.showModal();
          if (!type) {
            this.$notify({
              type: "success",
              text: res.message,
            });
          }
        })
        .catch(() => {});
    },

    getMeCall() {
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          if (res.mobile) {
            localStorage.setItem("mobile", res.mobile);
          }
          if (res.email) {
            localStorage.setItem("email", res.email);
          }
          if (res.is_membership_subscribed) {
            localStorage.setItem(
              "is_membership_subscribed",
              res.is_membership_subscribed
            );
          } else {
            localStorage.setItem("is_membership_subscribed", "N");
          }

          this.$store.commit("setUser", res);
          if (res.gender) {
            localStorage.setItem("gender", res.gender);
          }
          if (this.currentTab == "mobile" && res.is_verified_mobile == "N") {
            this.$refs.loginModal.closeModal();
            this.$refs.errorComponent.updateFormLoader(true);
            this.resendOtp("VERIFICATION");
          } else if (
            this.currentTab == "email" &&
            res.is_verified_email == "N"
          ) {
            this.$refs.loginModal.closeModal();
            this.$refs.errorComponent.updateFormLoader(true);
            this.resendOtp("VERIFICATION");
          } else if (
            res.is_verified_mobile == "Y" ||
            res.is_verified_email == "Y"
          ) {
            this.$router.push("/dashboard");
          }
        })
        .catch(() => {});
    },
    switchVisibilityNew() {
      this.newPasswordFieldType =
        this.newPasswordFieldType === "password" ? "text" : "password";
      this.imageNew =
        this.imageNew === "/images/show-psw.svg"
          ? "/images/hide-psw.svg"
          : "/images/show-psw.svg";
    },
  },
};
</script>
<style>
.outer-nav-ul > .nav-item > .nav-link {
 color: #000 !important;
}
</style>
